import React from "react";
import {connect} from "react-redux";
import axios from "axios";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {INewParcelaSection, INotificacion, IParcela, ISections} from "../../../types";
import Caracterizacion from "./Caracterizacion";
import Ubicacion from "./Ubicacion";
import Sectores from "./Sectores";
import {userService} from "../../../services/UserService";
const config = require('../../../config.json');
const texts = require('../../../texts/crearparcela.json');


interface IProps {
    seccion: INewParcelaSection
    menu: boolean
    parcelas: IParcela[]
    usuario: string
    level: number
    idioma: string
    notify(notification: INotificacion): void
    selectSection(section: ISections): void
    setLimiteHa(limiteHa: number): void
}

interface IState {
    text: Record<string, string>
}

class CrearParcela extends React.Component<IProps, IState> {
    state: IState = {
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    componentDidMount() {
        let n_parcelas = 0
        for (let parcela of this.props.parcelas) {
            if (parcela["propietario"].split(",").includes(userService.getUser())) {
                n_parcelas += 1
            }
        }

        if (this.props.level !== 5) {
            axios.get(
                config.url+`/get/limite/parcelas`,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then((res) => {

                    if (n_parcelas >= res.data.limit) {
                        this.props.notify({message: this.state.text["71"], variant: 'warning'})
                        setTimeout(() => {this.props.selectSection("principal")}, 2000)
                    }
                })
                .catch(() => {
                    this.props.notify({message: this.state.text["1"], variant: 'error'})
                    this.props.selectSection("principal")
                })
        }

        if (this.props.level === 5 || this.props.level === 3 || this.props.level === 2) {
            this.props.setLimiteHa(1000)
        } else {
            let parcelas = []
            for (let parcela of this.props.parcelas) {
                if (parcela.propietario.split(',').includes(this.props.usuario)) parcelas.push(parcela.id)
            }
            const parcelas_str = parcelas.join(',')
            axios.get(
                config.url+`/superficie/disponible?parcelas=${parcelas_str}`,
                // config.url+`/ok`,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then((res) => {

                    if (res.data.superficie <= 0) {
                        this.props.notify({message: this.state.text["0"], variant: 'warning'})
                        setTimeout(() => {this.props.selectSection("principal")}, 2000)
                    } else {
                        this.props.setLimiteHa(res.data.superficie)
                    }

                })
                .catch(() => {
                    this.props.notify({message: this.state.text["1"], variant: 'error'})
                    this.props.selectSection("principal")
                })
        }
    }

    chooseSection = () => {
        switch (this.props.seccion) {
            case 'Caracterización':
                return <Caracterizacion/>;
            case 'Ubicación':
                return <Ubicacion/>;
            case 'Sectores':
                return <Sectores/>;
            case 'InfoFinal':
                return <Sectores/>
            case 'AyudaParcela':
                return <Ubicacion/>
            case 'AyudaSector':
                return <Sectores/>
            default:
                return <div style={{marginTop: 20}}>{this.state.text["2"]}</div>
        }
    };

    render () {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignSelf: "start",
                    height: '100%',
                    width: '100%'
                }}
            >
                <div style={{width: '100%'}}>
                    {this.chooseSection()}
                </div>
            </div>
        )
    }

}


const mapStateToProps = (state: IStore) => ({
    seccion: state.crearParcela.seccion,
    menu: state.navegacion.menu,
    parcelas: state.principal.parcelas,
    usuario: state.principal.usuario,
    level: state.navegacion.level,
    idioma: state.config.idioma,
    usuarios: state.principal.usuarios
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    selectSection: (section: ISections) => dispatch({type: "select-section", section}),
    setLimiteHa: (limiteHa: number) => dispatch({type: "set-crear-parcela-limiteHa", limiteHa})
});

export default connect(mapStateToProps, mapDispatchToProps)(CrearParcela);
